import React, { useCallback } from 'react';

import { FormHoc, TextArea } from '../../atoms/Form';
import { useDialog } from '../../atoms/Dialog';
import { Forb, ForbBase, ForbBaseValidation, forbCreate, forbUpdate } from '../../../api';
import useApi from '../../../hooks/useApi';
import SendingContainer from '../../hoc/SendingContainer';

interface IFormOdpovedProps {
    data?: Forb
    reload: () => void
}

function FormOdpoved({ data, reload }: IFormOdpovedProps) {
    const { call: newForb, sending: sendingN, error: errorN } = useApi<void, ForbBase>({});
    const { call: updForb, sending: sendingU, error: errorU } = useApi<void, Forb>({});
    const { closeDialog } = useDialog();

    const onSubmit = useCallback(
        async (values: any) => {
            let response;
            if (values?.id)
                response = await updForb(forbUpdate(values.id, values))
            else
                response = await newForb(forbCreate(values));

            if (response !== false) {
                reload();
                closeDialog();
            }
        },
        [closeDialog, newForb, updForb, reload]
    );

    return (
        <SendingContainer sending={sendingN || sendingU} error={errorN || errorU}>

            <FormHoc
                onSubmit={onSubmit}
                defaultValues={data}
                validationSchema={ForbBaseValidation}
            >
                {
                    ({ submitHandler }) => (
                        <form
                            onSubmit={submitHandler}
                            noValidate>
                            <TextArea
                                name='answer'
                                label='Odpověď' />
                            <button
                                id='form-answer-submit'
                                className='display-none' />
                        </form>
                    )
                }
            </FormHoc>
        </SendingContainer>
    );
}

export default FormOdpoved;
